var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('div',{staticClass:"register-page"},[_c('div',{staticClass:"sidebar register-page-sidebar"},[_c('img',{staticClass:"register-page-img py-0 px-16",attrs:{"src":"/image/logo-white.png","alt":""}})]),_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }